<template>
  <div style="position: relative;overflow: hidden;min-height: 100vh">
    <div class="bg1">
      <div class="bg2"></div>
    </div>
    <div class="main">
      <div class="top1"></div>
      <div class="top2"></div>
      <div class="content">
        <div class="cardBox">
          <div class="bankName">鄞州银行</div>
          <div class="cardNum">810 161012314990100 0100</div>
        </div>
        <div style="overflow: hidden;margin: 20px 0">
          <div class="title">收款方账户名</div>
          <div class="titleContent">海上鲜待结算资金账户</div>
          <div class="title">开户银行</div>
          <div class="titleContent">鄞州银行</div>
          <div class="title">开户支行</div>
          <div class="titleContent">锦屏支行</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "accountInfo"
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 62px;
  left: 50px;
  right: 50px;
  z-index: 1;
  background: #fff;
  overflow: hidden;
  box-shadow: 0px 5px 20px 0px rgba(120, 120, 120, 0.3);
  border-radius: 18px 18px 0px 0px;
}
.bg1 {
  position: relative;
  margin: 47px 30px 0 30px;
  height: 30px;
  overflow: hidden;
}
.bg2 {
  margin: 10px;
  height: 10px;
  background: rgba(145, 145, 145, 1);
  border-radius: 5px;
}
.top1 {
  height: 42px;
  background: url("../../assets/top1.png") no-repeat;
  background-size: 100% 100%;
}
.top2 {
  height: 40px;
  background: url("../../assets/top2.png") no-repeat;
  background-size: 100% 100%;
}
.content {
  margin: 20px;
  overflow: hidden;
}
.cardBox {
  width: 100%;
  height: 230px;
  background: url("../../assets/bg3.png");
  background-size: 100% 100%;
  border-radius: 20px;
}
.bankName {
  padding: 30px 20px;
  font-weight: bold;
  color: #fff;
}
.cardNum {
  font-size: 16px;
  font-weight: bold;
  margin: 0 20px;
  color: #fff;
}
.title {
  height: 70px;
  line-height: 70px;
  margin-left: 31px;
  font-size: 14px;
  color: #777777;
}
.titleContent {
  margin: 0 14px;
  height: 70px;
  line-height: 70px;
  color: #262626;
  font-size: 14px;
  padding-left: 18px;
  background: #f0f1f3;
}
</style>
